import { z } from 'zod';
import { USER_ROLES } from './enums.js';
import { idSchema } from './common.schema.js';
export const userSchema = z.object({
    id: idSchema,
    email: z.string(),
    fullName: z.string(),
    role: z.enum(USER_ROLES),
    isActive: z.boolean(),
    /** Only populated for SITE_MANAGER users. */
    projectIds: z.array(idSchema),
});
export const createUserSchema = z.object({
    email: z.string().min(1, 'Podaj adres e-mail').email('Nieprawidłowy adres e-mail'),
    fullName: z.string().min(2, 'Podaj imię i nazwisko'),
    role: z.enum(USER_ROLES),
    /** Optional: when omitted, the user receives a set-password e-mail. */
    password: z.string().min(10, 'Hasło musi mieć co najmniej 10 znaków').optional(),
    projectIds: z.array(idSchema).default([]),
});
export const updateUserSchema = createUserSchema
    .omit({ password: true })
    .partial()
    .extend({ isActive: z.boolean().optional() });
//# sourceMappingURL=user.schema.js.map